import React from 'react';

/**
 * Return list of items
 *
 * @items :  list of items to show
 * @resourceName : name of prop expected by the component 
 * @itemComponent : Component to use for display items
 *
 * Example of compoent Item 
 * 
 *  export const SmallPersonList({person})=>{
 *       const{name,age}=person;
 *
 *        return{
 *             <p>Name{name}, Age:{age} years</p>
 *        }
 *    } 
 *
*/


export const List = ({
    items,
    resourceName,
    itemComponent: ItemComponent,



}) => {


    return (
        <>
            {items && items.map((item, index) => (
                <ItemComponent key={index}{...{ [resourceName]: item }} />  // {...{ [resouceName]:item }} its the same like  person={item} 
            ))}
        </>
    )
}